import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export async function getInvites() {
  const response = await fetcher.get({
    path: '/invites/organization',
  });
  return response;
}

export async function getInviteById(id) {
  const response = await fetcher.get({
    path: `/invites/${id}/public`,
  });
  return response;
}

export async function sendInvite(data) {
  const response = await fetcher.post({
    path: '/invites/send',
    body: data,
  });
  return response;
}

export async function resendInvite(id) {
  const response = await fetcher.post({
    path: '/invites/resend',
    body: { id },
  });
  return response;
}

export async function acceptInvite(data) {
  const response = await fetcher.post({
    path: '/invites/accept',
    body: data,
  });
  return response;
}

export async function deleteInvite(id) {
  const response = await fetcher.delete({
    path: '/invites',
    body: {
      id,
    },
  });
  return response;
}
